import { render, staticRenderFns } from "./oldClass.vue?vue&type=template&id=45bf051d&"
import script from "./oldClass.vue?vue&type=script&lang=js&"
export * from "./oldClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports